import { BaseSVGType } from '@/components/common/svg/types/svgTypes.ts';

const UserCheckShape = ({
  width = 36,
  height = 36,
  fillColor = 'none',
  style
}: BaseSVGType) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 25 25"
    fill={fillColor}
    style={style}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_329_161)">
      <path
        d="M11.1753 16.2799C11.8649 16.2479 12.4499 16.781 12.4819 17.4706C12.5139 18.1602 11.9808 18.7452 11.2912 18.7772C8.58782 18.9027 6.5754 19.4573 5.15619 20.3417C4.25374 20.9041 3.56153 21.6174 3.07214 22.5H11.2688C11.9592 22.5 12.5188 23.0597 12.5188 23.75C12.5188 24.4403 11.9592 25 11.2688 25H1.25C0.863609 25 0.498942 24.8213 0.262174 24.516C0.0254073 24.2106 -0.0568315 23.8129 0.0393961 23.4387C0.616874 21.193 1.89047 19.4311 3.83395 18.22C5.7425 17.0306 8.22223 16.417 11.1753 16.2799ZM17.5 7.5C17.5 4.73858 15.2614 2.5 12.5 2.5C9.73857 2.5 7.5 4.73858 7.5 7.5C7.5 10.2614 9.73857 12.5 12.5 12.5C15.2614 12.5 17.5 10.2614 17.5 7.5ZM20 7.5C20 11.6421 16.6421 15 12.5 15C8.35786 15 5 11.6421 5 7.5C5 3.35786 8.35786 0 12.5 0C16.6421 0 20 3.35786 20 7.5Z"
        fill="black"
      />
      <path
        d="M22.8298 17.4051C23.2943 16.8944 24.0848 16.8568 24.5956 17.3213C25.1063 17.7857 25.1439 18.5763 24.6794 19.087L19.6747 24.5908C19.4454 24.8431 19.123 24.9907 18.7822 24.9995C18.4414 25.0083 18.1117 24.8775 17.8697 24.6374L14.7331 21.5267C14.2429 21.0406 14.2396 20.2491 14.7257 19.759C15.2119 19.2688 16.0033 19.2655 16.4935 19.7516L18.7033 21.9432L22.8298 17.4051Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_329_161">
        <rect width="25" height="25" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default UserCheckShape;
